export default {
  // bind(el, binding, vnode) { },
  unbind(el, binding, vnode) {
    const { value: selector /* , modifiers */ } = binding
    const $el = selector ? el.querySelector(selector) : el.el
    $el.removeEventListener('paste', (e) => onPaste(e, el, binding, vnode))
  },
  inserted(el, binding, vnode) {
    const { value: selector /* , modifiers */ } = binding
    const $el = selector ? el.querySelector(selector) : el.el
    $el.addEventListener('paste', (e) => onPaste(e, el, binding, vnode))
  }
  // update(el, binding, vnode) {}
}

function onPaste(e, el, binding, vnode) {
  e.preventDefault()
  const paste = (e.clipboardData ?? window.clipboardData).getData('text')
  vnode.child.$emit('paste', paste)
}
